<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name',validatorRules.name]" placeholder="请输入公司名称" :disabled="!addFlag"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="公司编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['code',validatorRules.code]" placeholder="请输入公司编码" :disabled="!addFlag"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="hasParent">
            <a-form-item label="上级公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag dictCode="biz_insurance_company,name,id" v-decorator="['parentId', {}]" disabled>
              </j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="公司类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-decorator="[ 'companyType', validatorRules.companyType]" placeholder="请选择公司类型" :getPopupContainer= "(target) => target.parentNode" >
                <a-select-option value="0">保险公司</a-select-option>
                <a-select-option value="1">客户</a-select-option>
                <a-select-option value="2">其他</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="公司状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-decorator="[ 'status', validatorRules.status]" placeholder="请选择状态" :getPopupContainer= "(target) => target.parentNode" >
                <a-select-option value="1">正常</a-select-option>
                <a-select-option value="2">冻结</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!--禁用，目前用不到; 放开时需要把文件上传功能完善，防止形成无效文件-->
          <!--<a-col :span="24">
            <a-form-item label="公司logo" :labelCol="labelCol" :wrapperCol="wrapperCol" disabled>
              <j-image-upload v-decorator="['logo']" disabled></j-image-upload>
            </a-form-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-item label="电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['phone', validatorRules.phone]" placeholder="请输入电话"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['maill', validatorRules.mail]" placeholder="请输入邮箱"></a-input>
            </a-form-item>
          </a-col>

          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSelectProductTypes from '@/components/jeecgbiz/JSelectProductTypes'

  export default {
    name: 'InsuranceCompanyForm',
    components: {
      JFormContainer,
      JImageUpload,
      JDictSelectTag,
      JSelectProductTypes
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        addFlag: true, //是否新增
        hasParent: false,
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          name:{
            rules:[
              {required: true, message: '请输入公司名称'},
              {max: 30, message:'公司名字不能超过30个字符'}
            ]
          },
          code:{
            rules:[
              {required: true, message: '请输入公司编码'},
              {max: 20, message:'公司编码不能超过20个字符'}
            ]
          },
          status:{
            rules:[
              {required: true, message: '请选择公司状态'}
            ]
          },
          phone:{
            rules:[
              {max: 13, message:'请输入正确的电话号码'}
            ]
          },
          mail:{
            rules:[
              {type: 'email', message:'请输入正确的邮箱地址'},
              {max: 30, message: '邮箱长度不能超过30个字符'}
            ]
          }
        },
        url: {
          add: "/jeecg/insuranceCompany/add",
          edit: "/jeecg/insuranceCompany/edit",
          queryById: "/jeecg/insuranceCompany/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      // this.showFlowData();
    },
    methods: {
      add (parentId) {
        if(parentId != null){
          this.hasParent = true;
        } else {
          this.hasParent = false;
        }
        this.edit({parentId: parentId});
        this.addFlag = true;
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.addFlag = true;
        if(record === undefined || record === null || Object.keys(record).length === 0){
          this.addFlag = true;
        } else {
          this.addFlag = false;
        }

        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'name', 'code', 'status','logo','phone', 'maill','parentId','companyType'))
        })
      },
      //渲染流程表单数据
      // showFlowData(){
      //   if(this.formBpm === true){
      //     let params = {id:this.formData.dataId};
      //     getAction(this.url.queryById,params).then((res)=>{
      //       if(res.success){
      //         this.edit (res.result);
      //       }
      //     });
      //   }
      // },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'name','status','logo','maill','parentId','companyType'))
      },
    }
  }
</script>